export default __webpack_public_path__ + "static/media/property_663.8965be32.png";